export enum etapeImportDepensesManuelles {
	selectionFichier = 1,
	validationReussi = 2,
	validationErreur = 3
}